import { sendAnalysisToWebhook } from '../webhook/analysisWebhookService';
import type { AnalysisFormData } from '../webhook/types';

export const submitAnalysisForm = async (data: AnalysisFormData) => {
  try {
    await sendAnalysisToWebhook(data);
    return true;
  } catch (error) {
    console.error('Analysis form submission failed:', error);
    throw new Error('Failed to submit analysis request. Please try again.');
  }
};